export default __webpack_public_path__ + "static/Alliance_Autos_2050_lockup-01cf105e6db18d8eec89bf3002d93f9c.png";